export default function ({ redirect }) {
  if (!window.localStorage.getItem('authUser')) {
    return redirect('/');
  }

  const storedUser = JSON.parse(window.localStorage.getItem('authUser'));

  if (!storedUser.user.roles.includes('admin')) {
    return redirect('/');
  }
}